export default __webpack_public_path__ + "static/media/9.7a23ca83.png";